module.exports = __webpack_public_path__ + "img/arrival-transfer-centurion0_0.7b57520a.jpg";